export type ThemeKey = 'freshMint' | 'citrusSunrise' | 'calmSlate';

export interface ThemeDefinition {
  key: ThemeKey;
  name: string;
  properties: Record<string, string>;
}

export const themes: ThemeDefinition[] = [
  {
    key: 'freshMint',
    name: 'Fresh Mint',
    properties: {
      '--color-bg': '#f2f9f5',
      '--color-surface': '#ffffff',
      '--color-border': '#cde6d9',
      '--color-text': '#143329',
      '--color-muted': '#4f6b5e',
      '--color-accent': '#ff914d',
      '--color-accent-contrast': '#ffffff',
      '--color-highlight': '#2ab675',
      '--color-header-bg': '#d8f3e4',
      '--color-footer-bg': '#e6f7ee',
      '--shadow-soft': '0 10px 30px rgba(34, 80, 58, 0.15)',
    },
  },
  {
    key: 'citrusSunrise',
    name: 'Citrus Sunrise',
    properties: {
      '--color-bg': '#fff7f0',
      '--color-surface': '#ffffff',
      '--color-border': '#ffd9bf',
      '--color-text': '#3a2f28',
      '--color-muted': '#7b5f4f',
      '--color-accent': '#ffb347',
      '--color-accent-contrast': '#3a2f28',
      '--color-highlight': '#68c49b',
      '--color-header-bg': '#ffe7cf',
      '--color-footer-bg': '#ffeeda',
      '--shadow-soft': '0 12px 32px rgba(173, 92, 28, 0.16)',
    },
  },
  {
    key: 'calmSlate',
    name: 'Calm Slate',
    properties: {
      '--color-bg': '#e9f1ef',
      '--color-surface': '#f7fbfa',
      '--color-border': '#b9c9c4',
      '--color-text': '#122024',
      '--color-muted': '#4b5d63',
      '--color-accent': '#ff9b5a',
      '--color-accent-contrast': '#1f2f33',
      '--color-highlight': '#58bfa2',
      '--color-header-bg': '#1f2f33',
      '--color-footer-bg': '#253a3f',
      '--shadow-soft': '0 10px 28px rgba(18, 32, 36, 0.18)',
    },
  },
];

export const themeMap = themes.reduce<Record<ThemeKey, ThemeDefinition>>((acc, theme) => {
  acc[theme.key] = theme;
  return acc;
}, {} as Record<ThemeKey, ThemeDefinition>);

export const defaultThemeKey: ThemeKey = 'freshMint';
